import styled from 'styled-components';

export const MainContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 15px;
    margin-bottom: 40px;
    margin-left: 4%;
    width: 100%;
`;

export const GameoverContainer = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;
